import { Link } from "react-router-dom";
import { ArrowLeft, Package } from "lucide-react";
import { getSiteProfile } from "../lib/site-profile";

/** Minimal CaribNavi shell for marketplace catalog pages (variation-locked products). */
export default function NaviCatalogLayout({ children, title = "Marketplace" }) {
  const profile = getSiteProfile();
  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-50 via-white to-slate-50 text-slate-900">
      <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900"
          >
            <ArrowLeft className="h-4 w-4" />
            {profile.brandName}
          </Link>
          <div className="flex items-center gap-2 text-sm font-semibold text-cyan-800">
            <Package className="h-4 w-4" />
            {title}
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
